// Full list of permissions: https://app.clickup.com/24423001/v/dc/q9ajt-15101/q9ajt-8741
export const PERMISSIONS = {
    BETTERSPACE_ADMIN: {
        CREATE: "BETTERSPACE.ADMIN.CREATE",
        READ: "BETTERSPACE.ADMIN.READ",
        UPDATE: "BETTERSPACE.ADMIN.UPDATE",
        DELETE: "BETTERSPACE.ADMIN.DELETE",
    },
    SPACE: {
        CREATE: "SPACE.CREATE",
        READ: "SPACE.READ",
        UPDATE: "SPACE.UPDATE",
        DELETE: "SPACE.DELETE",
    },
    USER: {
        CREATE: "USER.CREATE",
        READ: "USER.READ",
        UPDATE: "USER.UPDATE",
        DELETE: "USER.DELETE",
    },
    DEVICE: {
        CREATE: "DEVICE.CREATE",
        READ: "DEVICE.READ",
        UPDATE: "DEVICE.UPDATE",
        DELETE: "DEVICE.DELETE",
    },
    DEVICE_ADVANCED_SETTINGS: {
        READ: "DEVICE.ADVANCED_SETTINGS.READ",
        UPDATE: "DEVICE.ADVANCED_SETTINGS.UPDATE",
    },
    OCCUPANCY: {
        CREATE: "OCCUPANCY.CREATE",
        READ: "OCCUPANCY.READ",
        UPDATE: "OCCUPANCY.UPDATE",
        DELETE: "OCCUPANCY.DELETE",
    },
    COMPANY: {
        CREATE: "COMPANY.CREATE",
        READ: "COMPANY.READ",
        UPDATE: "COMPANY.UPDATE",
        DELETE: "COMPANY.DELETE",
    },
    LOCATION: {
        CREATE: "LOCATION.CREATE",
        READ: "LOCATION.READ",
        UPDATE: "LOCATION.UPDATE",
        DELETE: "LOCATION.DELETE",
        SOFTWARE_VERSION_TYPE_READ: "LOCATION.SOFTWARE_VERSION_TYPE.READ",
    },
    TEMPERATURE: {
        LOCK: "TEMPERATURE.LOCK",
    },
    RULESET: {
        CREATE: "RULESET.CREATE",
        READ: "RULESET.READ",
        UPDATE: "RULESET.UPDATE",
        DELETE: "RULESET.DELETE",
        LOCK: "RULESET.LOCK",
    },
    ENERGY_SETTINGS: {
        READ: "ENERGY.SETTINGS.READ",
        UPDATE: "ENERGY.SETTINGS.UPDATE",
        DELETE: "ENERGY.SETTINGS.DELETE",
        CREATE: "ENERGY.SETTINGS.CREATE",
    },
    ENERGY_MONITOR: {
        READ: "ENERGY.MONITOR.READ",
        ASSIGN: "ENERGY.MONITOR.ASSIGN",
    },
    ENERGY_MODE: {
        CREATE: "ENERGY.MODE.CREATE",
        READ: "ENERGY.MODE.READ",
        UPDATE: "ENERGY.MODE.UPDATE",
        DELETE: "ENERGY.MODE.DELETE",
        LOCK: "ENERGY.MODE.LOCK",
    },
    ANALYZE_MEASURES: {
        CREATE: "ENERGY.ANALYZE.MEASURES.CREATE",
        UPDATE: "ENERGY.ANALYZE.MEASURES.UPDATE",
        DELETE: "ENERGY.ANALYZE.MEASURES.DELETE",
    },
    NOTIFICATIONS: {
        READ: "NOTIFICATIONS.READ",
        UPDATE: "NOTIFICATIONS.UPDATE",
    },
    INTEGRATION: {
        READ: "INTEGRATION.READ",
        CREATE: "INTEGRATION.CREATE",
        UPDATE: "INTEGRATION.UPDATE",
        DELETE: "INTEGRATION.DELETE",
    },
    ANNOUNCEMENT: {
        CREATE: "ANNOUNCEMENT.CREATE",
        READ: "ANNOUNCEMENT.READ",
        UPDATE: "ANNOUNCEMENT.UPDATE",
        DELETE: "ANNOUNCEMENT.DELETE",
    },
};

// id to check wether permissions are present
// in any locations under a specific company
export const ANY_LOCATION_ID = "ANY";
